import type { CustomIconProps } from '../CustomIcon';

export const TextIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M5.76 15.856h-.896l.544-1.584h4.256l.544 1.584h-.912V17.2h3.76v-1.344h-1.072L8.384 6H6.672l-3.616 9.856H2V17.2h3.76v-1.344Zm1.776-7.808 1.664 4.88H5.856l1.68-4.88Z'
      fill={secondaryColor}
    />
    <path
      d='M21.473 15.856h-.944V12.08c0-2.048-1.024-3.072-3.392-3.072-1.232 0-2.225.192-2.817.464v2.192h1.425V10.48c.383-.08.832-.128 1.344-.128 1.152 0 1.728.64 1.728 1.728v.384h-1.584c-2.513 0-3.44.976-3.44 2.448 0 1.424.816 2.48 2.608 2.48 1.215 0 2.015-.496 2.495-1.216l.192 1.024h2.384v-1.344Zm-4.64.176c-.88 0-1.296-.48-1.296-1.152 0-.784.527-1.216 1.711-1.216h1.569v.56c-.049 1.072-.928 1.808-1.985 1.808Z'
      fill={color}
    />
  </svg>
);
